export class LoginI {
  username:string;
  password:string;
}
